import { useEffect } from "react";
import { toast } from "sonner";

// Detects when a newer frontend build has been deployed (production build only,
// where CRA emits asset-manifest.json). Shows a persistent toast with a Refresh
// action. No-ops gracefully in the dev preview (manifest 404), so no false alerts.
export function VersionWatcher() {
  useEffect(() => {
    let loadedMain = null;
    let stopped = false;

    const readMain = (data) => data?.files?.["main.js"] || data?.["main.js"] || null;

    const check = async () => {
      try {
        const res = await fetch(`/asset-manifest.json?ts=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const main = readMain(await res.json());
        if (!main) return;
        if (loadedMain === null) { loadedMain = main; return; }
        if (main !== loadedMain && !stopped) {
          stopped = true;
          toast("A new version of the app is available", {
            id: "app-update",
            description: "Refresh to get the latest features and fixes.",
            duration: Infinity,
            action: { label: "Refresh", onClick: () => window.location.reload() },
          });
        }
      } catch { /* offline or no manifest — ignore */ }
    };

    check();
    const id = setInterval(check, 60_000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, []);

  return null;
}
